import { Flex, Label } from "@braze/beacon-core";
import { ProgressBar } from "@braze/beacon-labs-progress-bar";

type ProgressMetricProps = {
    estimated: number;
    actual: number;
    title: string;
}
export const ProgressMetric = ({estimated, actual, title} : ProgressMetricProps) => {

    return (

        <Flex direction="row" style={{justifyContent: "space-between"}}>
            <Flex style={{width: "10%"}}>
                <Label>{title}</Label>
            </Flex>
            <Flex style={{width: "20%"}}>
                <Label>{actual}/{estimated}:</Label>
            </Flex>
            <div style={{width: "100%"}}>
                <ProgressBar 
                    colorByPercentage={{
                    '0': {
                        color: 'red',
                        intensity: 500
                    },
                    '30': {
                        color: 'orange',
                        intensity: 500
                    },
                    '75': {
                        color: 'lightBlue',
                        intensity: 500
                    },
                    '100': {
                        color: 'lightGreen',
                        intensity: 500
                    },
                    }}
                    percentage={actual/estimated*100}
                />
            </div>
            <Flex style={{width: "15%"}}>
                <Label style={{marginLeft: "auto", marginRight: "0px"}}>{Math.round(actual/estimated*100)} %</Label>
            </Flex>
            
            
            
        </Flex>
            
      
    )
};